// import React, { useState } from "react";
// import { Container, Row, Col, Modal } from "react-bootstrap";
// import GalleryHeroImg from "../../asset/Gallery.png";
// import GalleryIcon from "../../asset/camera.png";
// import "./Gallery.css";

// const importAll = (r) => r.keys().map(r);

// const galleryImages = importAll(
//   require.context("../../asset/Gallery", false, /\.(png|jpe?g|svg)$/)
// );

// const Gallery = () => {
//   const [show, setShow] = useState(false);
//   const [currentIndex, setCurrentIndex] = useState(null);

//   const handleShow = (index) => {
//     setCurrentIndex(index);
//     setShow(true);
//     document.querySelector(".gallery-section")?.classList.add("blurred");
//   };

//   const handleClose = () => {
//     setShow(false);
//     setCurrentIndex(null);
//     document.querySelector(".gallery-section")?.classList.remove("blurred");
//   };

//   const handlePrev = () => {
//     setCurrentIndex((prev) =>
//       prev === 0 ? galleryImages.length - 1 : prev - 1
//     );
//   };

//   const handleNext = () => {
//     setCurrentIndex((prev) =>
//       prev === galleryImages.length - 1 ? 0 : prev + 1
//     );
//   };

//   return (
//     <div>
//       {/* Hero Section */}
//       <div
//         className="gallery-hero"
//         style={{ backgroundImage: `url(${GalleryHeroImg})` }}
//       >
//         <div className="overlay"></div>
//         <div className="gallery-text-container">
//           <h1 className="gallery-heading">
//             <img src={GalleryIcon} alt="Gallery Icon" className="gallery-icon" />
//             Moments That Define Us
//           </h1>
//           <p className="gallery-paragraph">
//             Our gallery reflects the journey we've shared with clients,
//             colleagues, and communities — capturing milestones, achievements,
//             and the spirit of togetherness that drives us forward.
//           </p>
//         </div>
//       </div>

//       {/* Gallery Section */}
//       <div className="gallery-section g-0">
//         <Container>
//           <Row>
//             {galleryImages.map((img, index) => (
//               <Col lg={4} md={6} sm={12} className="mb-4 text-center" key={index}>
//                 <img
//                   src={img}
//                   alt={`Gallery ${index + 1}`}
//                   className="gallery-img"
//                   onClick={() => handleShow(index)}
//                   style={{ cursor: "pointer" }}
//                 />
//               </Col>
//             ))}
//           </Row>
//         </Container>
//       </div>

//       {/* Modal */}
//       <Modal
//         show={show}
//         onHide={handleClose}
//         centered
//         size="xl"
//         contentClassName="bg-transparent border-0 shadow-none"
//       >
//         <Modal.Body className="p-0 m-0 position-relative d-flex justify-content-center align-items-center">
//           {currentIndex !== null && (
//             <>
//               {/* Left Arrow */}
//               <span
//                 onClick={handlePrev}
//                 className="position-absolute top-50 start-0 translate-middle-y"
//                 style={{
//                   cursor: "pointer",
//                   fontSize: "50px",
//                   color: "white",
//                   userSelect: "none",
//                 }}
//               >
//                 ‹
//               </span>

//               {/* Image */}
//               <img
//                 src={galleryImages[currentIndex]}
//                 alt="Preview"
//                 style={{ maxWidth: "100%", maxHeight: "90vh" }}
//               />

//               {/* Right Arrow */}
//               <span
//                 onClick={handleNext}
//                 className="position-absolute top-50 end-0 translate-middle-y"
//                 style={{
//                   cursor: "pointer",
//                   fontSize: "50px",
//                   color: "white",
//                   userSelect: "none",
//                 }}
//               >
//                 ›
//               </span>
//             </>
//           )}
//         </Modal.Body>
//       </Modal>
//     </div>
//   );
// };

// export default Gallery;
import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Modal, Spinner } from "react-bootstrap";
import GalleryHeroImg from "../../asset/Gallery.webp";
import GalleryIcon from "../../asset/camera.png";
import "./Gallery.css";

// ✅ Step 1: Import all images from the Gallery folder
const importAll = (r) => r.keys().map(r);
const galleryImages = importAll(
  require.context("../../asset/Gallery", false, /\.(png|jpe?g|webp|svg)$/)
);

const Gallery = () => {
  const [show, setShow] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [loadedImages, setLoadedImages] = useState({});
  const observer = useRef(null);

  // ✅ Lazy load images using IntersectionObserver
  useEffect(() => {
    const options = { root: null, rootMargin: "0px", threshold: 0.1 };
    observer.current = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const img = entry.target;
          const src = img.getAttribute("data-src");
          if (src) {
            img.src = src;
            img.onload = () => {
              setLoadedImages((prev) => ({ ...prev, [src]: true }));
              img.classList.add("loaded");
            };
            observer.current.unobserve(img);
          }
        }
      });
    }, options);

    const imgs = document.querySelectorAll(".lazy-image");
    imgs.forEach((img) => observer.current.observe(img));

    return () => observer.current?.disconnect();
  }, []);

  // ✅ Modal handlers
  const handleShow = (index) => {
    setCurrentIndex(index);
    setShow(true);
    document.querySelector(".gallery-section")?.classList.add("blurred");
  };

  const handleClose = () => {
    setShow(false);
    setCurrentIndex(null);
    document.querySelector(".gallery-section")?.classList.remove("blurred");
  };

  const handlePrev = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? galleryImages.length - 1 : prev - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prev) =>
      prev === galleryImages.length - 1 ? 0 : prev + 1
    );
  };

  return (
    <div>
      {/* Hero Section */}
      <div
        className="gallery-hero"
        style={{ backgroundImage: `url(${GalleryHeroImg})` }}
      >
        <div className="overlay"></div>
        <div className="gallery-text-container">
          <h1 className="gallery-heading">
            <img src={GalleryIcon} alt="Gallery Icon" className="gallery-icon" />
            Moments That Define Us
          </h1>
          <p className="gallery-paragraph">
            Our gallery reflects the journey we've shared with clients,
            colleagues, and communities — capturing milestones, achievements,
            and the spirit of togetherness that drives us forward.
          </p>
        </div>
      </div>

      {/* Gallery Grid */}
      <div className="gallery-section g-0">
        <Container>
          <Row>
            {galleryImages.map((img, index) => (
              <Col lg={4} md={6} sm={12} className="mb-4 text-center" key={index}>
                <div className="image-wrapper">
                  {!loadedImages[img] && (
                    <Spinner
                      animation="border"
                      variant="light"
                      size="sm"
                      className="spinner"
                    />
                  )}
                  <img
                    data-src={img}
                    alt={`Gallery ${index + 1}`}
                    className="gallery-img lazy-image"
                    onClick={() => handleShow(index)}
                    style={{ cursor: "pointer" }}
                    loading="lazy"
                  />
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>

      {/* Modal Viewer */}
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="xl"
        contentClassName="bg-transparent border-0 shadow-none"
      >
        <Modal.Body className="p-0 m-0 position-relative d-flex justify-content-center align-items-center">
          {currentIndex !== null && (
            <>
              {/* Left Arrow */}
              <span
                onClick={handlePrev}
                className="position-absolute top-50 start-0 translate-middle-y nav-arrow"
                style={{ cursor: "pointer", fontSize: "50px", color: "white", userSelect: "none" }}
              >
                ‹
              </span>

              {/* Image */}
              <img
                src={galleryImages[currentIndex]}
                alt="Preview"
                className="modal-image"
                style={{ maxWidth: "100%", maxHeight: "90vh" }}
              />

              {/* Right Arrow */}
              <span
                onClick={handleNext}
                className="position-absolute top-50 end-0 translate-middle-y nav-arrow"
                style={{ cursor: "pointer", fontSize: "50px", color: "white", userSelect: "none" }}
              >
                ›
              </span>
            </>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Gallery;
